import React from "react";
import { Users } from "lucide-react";
import PageBanner from "./PageBanner";
import Team from "./Team";

export default function TeamPage() {
  return (
    <div className="min-h-screen bg-[#fafcff]">
      <PageBanner
        title="Our Team"
        description="Meet the passionate people behind IEEE ISIMS Student Branch — the leaders, dreamers, and doers who make it all happen."
        Icon={Users}
      />
      <Team />
    </div>
  );
}
